export default __webpack_public_path__ + "static/commmune-introduction-aab106677a027146e7748a5518b8c2fc.jpg";